import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { routing } from './first-registration-step.routing';
import { FirstRegistrationStepComponent } from './first-registration-step.component';
import { SharedModule } from '../../../components/shared/shared.module';
import { FormModule } from '../../../components/form-fields/form.module';
import { FunnelModule } from '../../../funnel/funnel.module';
import { ConfirmationSmsModule } from '../../confirmation-sms/confirmation-sms.module';
import { RulesComponent } from '../../../components/shared/components/rules/rules.component';
import {
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaModule,
  RecaptchaV3Module,
} from 'ng-recaptcha';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogModule,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DialogModule } from 'primeng/dialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { environment } from '../../../../environments/environment';
import { TidService } from '../../../services/tid.service';

@NgModule({
  imports: [
    CommonModule,
    routing,
    SharedModule,
    FormModule,
    FunnelModule,
    ConfirmationSmsModule,
    RecaptchaV3Module,
    RecaptchaModule,
    ButtonModule,
    CheckboxModule,
    DynamicDialogModule,
    SelectButtonModule,
    DialogModule,
    OverlayPanelModule,
    NgOptimizedImage,
  ],
  declarations: [FirstRegistrationStepComponent, RulesComponent],
  providers: [
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
    TidService,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.captchaKey,
    },
  ],
})
export class FirstRegistrationStepModule {}
